export function getLastBusinessId() {
    return parseInt(localStorage.getItem('last-business-id'));
}

export function setLastBusinessId(id) {
    localStorage.setItem('last-business-id', id);
}
